// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	ALERT: '[data-fragment="JsonMessages.alert"]',
};

class JsonMessages extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
		this.state = {

		};

	}

	didMount() {
		this.alertElement = this.element.querySelector(fragments.ALERT);
	}

	showAlert = (type, text) => {
		this.element.classList.add('json-messages--show');
		this.alertElement.classList.add('alert-'+type);
		this.alertElement.innerText = text;
		if(type !== 'danger') {
			setTimeout(() => {
				this.element.classList.remove('json-messages--show');
			}, 3000);
		}
	};

}


export default JsonMessages;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/JsonMessages.js